import { render, staticRenderFns } from "./VolunteerLogItemCreate.vue?vue&type=template&id=09aba9b2"
import script from "./VolunteerLogItemCreate.vue?vue&type=script&lang=ts"
export * from "./VolunteerLogItemCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports